import 'react-datepicker/dist/react-datepicker.css';
import {registerLocale} from "react-datepicker";
import pt from 'date-fns/locale/pt-BR';
import { LOCALE_CODES } from "../../app/appConstants";

registerLocale(LOCALE_CODES.pt, pt);
